import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'sonner';
import { WifiOff, Wifi } from 'lucide-react';

export const OfflineDetector = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      if (wasOffline) {
        toast.success('Back online!', {
          description: 'Your connection has been restored.',
          icon: <Wifi className="w-4 h-4" />,
        });
        
        // If we were on the offline page, go back
        if (location.pathname === '/offline') {
          navigate(-1);
        }
      }
    };

    const handleOffline = () => {
      setIsOnline(false);
      setWasOffline(true);
      toast.error('You are offline', {
        description: 'Some features may be limited.',
        icon: <WifiOff className="w-4 h-4" />,
        duration: 5000,
      });
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [wasOffline, navigate, location.pathname]);

  // Offline banner for persistent indicator
  if (!isOnline) {
    return (
      <div className="fixed top-0 left-0 right-0 z-[100] bg-destructive text-destructive-foreground py-1.5 px-4 text-center text-sm font-medium flex items-center justify-center gap-2 animate-in slide-in-from-top">
        <WifiOff className="w-4 h-4" />
        <span>You're offline. Some features may not work.</span>
      </div>
    );
  }

  return null;
};
